import ForecastingUtilService from '@/services/forecastingUtilService'
import momentCache from "@/services/momentCache"

function getForecastsByDate(forecasts){
    let map = {};

    let length = forecasts.length;
    for(let i = 0; i < length; i++){
        let forecast = forecasts[i];

        let date = momentCache.getMoment(forecast.forecastDate).format("YYYY-MM-DD");
        let key = `${date}`;
        if(map[key] == null){
            map[key] = [];
        }
        map[key].push(forecast);
    }

    return map;
}

function getNuPointSpraysByDateAndLocation(nuPointSprays){
    let map = {};

    let length = nuPointSprays.length;
    for(let i = 0; i < length; i++){
        let nuPointSpray = nuPointSprays[i];

        let date = momentCache.getMoment(nuPointSpray.NuPointSprayDate).format("YYYY-MM-DD");
        let key = `${date}-${nuPointSpray.LocationID}`;
        if(map[key] == null){
            map[key] = [];
        }
        map[key].push(nuPointSpray);
    }

    return map;
}

function getCropByCropLocationId(crops){
    let map = {};

    let length = crops.length;
    for(let i = 0; i < length; i++){
        let crop = crops[i];

        let cropLocationId = crop.cropLocationId;
        let key = `${cropLocationId}`;
        if(map[key] == null){
            map[key] = crop;
        }
    }

    return map;
}

function getVarietyByCropLocationIdVarietyId(varieties){
    let map = {};

    let length = varieties.length;
    for(let i = 0; i < length; i++){
        let variety = varieties[i];

        let cropLocationId = variety.cropLocationId;
        let varietyId = variety.varietyId;
        let key = `${cropLocationId}-${varietyId}`;
        if(map[key] == null){
            map[key] = variety;
        }
    }

    return map;
}

function getForecastByDateCropLocationIdVarietyId(forecasts){
    let map = {};

    let length = forecasts.length;
    for(let i = 0; i < length; i++){
        let forecast = forecasts[i];

        let date = momentCache.getMoment(forecast.forecastDate).format("YYYY-MM-DD");
        let cropLocationId = forecast.cropLocationId;
        let varietyId = forecast.varietyId;
        let key = `${date}-${cropLocationId}-${varietyId}`;
        if(map[key] == null){
            map[key] = forecast;
        }
    }

    return map;
}

function getNotesByCropLocationIdVarietyId(notes){
    let map = {};

    let length = notes.length;
    for(let i = 0; i < length; i++){
        let note = notes[i];

        let cropLocationId = note.cropLocationId;
        let varietyId = note.varietyId;
        let key = `${cropLocationId}-${varietyId}`;
        if(map[key] == null){
            map[key] = [];
        }
        map[key].push(note);
    }

    return map;
}

function getIncludedVarietiesByCropLocationIdVarietyId(varieties, cropByCropLocationId, filterDivisionIds, filterLocationName, filterVarietyIds, filterLocationIds){
    let map = {};

    let length = varieties.length;
    for(let i = 0; i < length; i++){
        let variety = varieties[i];

        let cropLocationId = variety.cropLocationId;
        let varietyId = variety.varietyId;

        // Retrieve crop
        let cropKey = `${cropLocationId}`;
        let crop = cropByCropLocationId[cropKey];
        if(crop == null){
            continue;
        }

        // Apply division filter
        let divisionId = crop.divisionId;
        if(filterDivisionIds.length > 0 && filterDivisionIds.indexOf(divisionId) < 0){
            continue;
        }

        // Apply location name filter
        let locationName = crop.locationName;
        if(filterLocationName != null && !locationName.toLowerCase().trim().includes(filterLocationName.toLowerCase().trim())){
            continue;
        }

        // Apply location Id filter
        let locationId = crop.locationId;
        if(filterLocationIds.length > 0 && filterLocationIds.indexOf(locationId) < 0) {
            continue;
        }

        // Apply variety filter
        if(filterVarietyIds.length > 0 && filterVarietyIds.indexOf(varietyId) < 0){
            continue;
        }

        let key = `${cropLocationId}-${varietyId}`;
        if(map[key] == null){
            map[key] = true; // This map is just a lookup for if the variety key is included with the filters applied
        }
    }

    return map;
}

function getUpdatedData(
    financialYearCalendarData, 
    forecasts,
    yields, 
    allActiveLocations,
    varieties, 
    crops, 
    notes, 
    selectedDate, 
    filterLocationName, 
    filterVarietyIds, 
    filterDivisionIds,
    filterLocationIds, 
    today, 
    startOfSelectedWeek, 
    editable,
    allPublicHolidays,
    plantRegion,
    nuPointSprays,
    uomScaleFactor
){ 
    let data = {};    
    data.detailedWeeks = [];
    data.calendarDayTotals = [];
    data.calendarWeekTotals = [];
    data.listSortedItems = [];
    data.listNumberOfLocationsFiltered = [];
    data.calendarSortedItems = [];
    data.calendarNumberOfLocationsFiltered = [];

    let forecastsByDate = getForecastsByDate(forecasts);
    let cropByCropLocationId = getCropByCropLocationId(crops);
    let varietyByCropLocationIdVarietyId = getVarietyByCropLocationIdVarietyId(varieties);
    let forecastByDateCropLocationIdVarietyId = getForecastByDateCropLocationIdVarietyId(forecasts);
    let notesByCropLocationIdVarietyId = getNotesByCropLocationIdVarietyId(notes);
    let includedVarietiesByCropLocationIdVarietyId = getIncludedVarietiesByCropLocationIdVarietyId(varieties, cropByCropLocationId, filterDivisionIds, filterLocationName, filterVarietyIds, filterLocationIds);
    let nuPointSpraysByDateAndLocation = getNuPointSpraysByDateAndLocation(nuPointSprays);

    let varietyTotals = {};
    let calendarVarieties = [];
    let listVarieties = [];
    let daysInWeek = {};
    let dayGrandTotals = {};
    let weekGrandTotals = {};
    let detailedWeeks = {};
    let startOfTodayWeekUnixDays = ForecastingUtilService.unixDay(momentCache.createMoment(today).startOf('week'));
    let todayUnixDays = ForecastingUtilService.unixDay(momentCache.createMoment(today));
    let startOfSelectedWeekUnixDays = ForecastingUtilService.unixDay(momentCache.createMoment(startOfSelectedWeek));
    let currentDateMoment = momentCache.createMoment(selectedDate).add(-1, 'week').startOf('week');
    let currentWeekMoment = momentCache.createMoment(selectedDate).add(-1, 'week').startOf('week');
    
    // Used for debugging
    //let startDate = new Date();
    
    // change yields from a list to a dictionary
    let yieldMap = Object.assign({}, ...yields.map(y => ({[`${y.financialYear}-${y.financialWeek}-${y.locationId}-${y.varietyId}`]: y.yieldValue })));

    // Relevant Public Holidays
    const applicableHolidays = allPublicHolidays.filter(h => (
        h.Regions.some(r=>(r.Region==plantRegion))
    ))

    for(let i = 0; i < 7 * 7; i++){
        let date = currentDateMoment.format("YYYY-MM-DD");
        let dateKey = `${date}`;

        let week = currentWeekMoment.format("YYYY-MM-DD");
        let weekKey = `${week}`;

        // Build days in week
        if(daysInWeek[weekKey] == null){
            daysInWeek[weekKey] = [];
        }
        daysInWeek[weekKey].push(dateKey);

        // Build up a list of variety totals (overall, per week and per day)
        let forecasts = null
        if(forecastsByDate[dateKey] == null){
            forecasts = []
        } else {
            forecasts = forecastsByDate[dateKey];
        }

        // Tally up the forecasts for this day
        for(let j = 0; j < forecasts.length; j++){
            let forecast = forecasts[j];

            let varietyKey = `${forecast.cropLocationId}-${forecast.varietyId}`;

            // If this forecast is not for an included variety, skip it
            if(includedVarietiesByCropLocationIdVarietyId[varietyKey] == null){
                continue;
            }

            if(varietyTotals[varietyKey] == null){
                varietyTotals[varietyKey] = {
                    dates: {},
                    weeks: {},
                    overall: {
                        forecastValue: null,
                        adjustedValue: null,
                        actualValue: null
                    }
                };
            }

            if(varietyTotals[varietyKey].dates[dateKey] == null){
                varietyTotals[varietyKey].dates[dateKey] = {
                    forecastValue: null,
                    adjustedValue: null,
                    actualValue: null
                };
            }

            if(varietyTotals[varietyKey].weeks[weekKey] == null){
                varietyTotals[varietyKey].weeks[weekKey] = {
                    forecastValue: null,
                    adjustedValue: null,
                    actualValue: null
                };
            }

            let forecastValue = forecast.forecastValue;
            if(forecastValue != null){
                forecastValue = Math.round(parseInt(forecast.forecastValue) * uomScaleFactor);

                if(varietyTotals[varietyKey].overall.forecastValue == null){
                    varietyTotals[varietyKey].overall.forecastValue = 0;
                }
                varietyTotals[varietyKey].overall.forecastValue += parseInt(forecastValue);

                if(varietyTotals[varietyKey].dates[dateKey].forecastValue == null){
                    varietyTotals[varietyKey].dates[dateKey].forecastValue = 0;
                }
                varietyTotals[varietyKey].dates[dateKey].forecastValue += parseInt(forecastValue);

                if(varietyTotals[varietyKey].weeks[weekKey].forecastValue == null){
                    varietyTotals[varietyKey].weeks[weekKey].forecastValue = 0;
                }
                varietyTotals[varietyKey].weeks[weekKey].forecastValue += parseInt(forecastValue);
            }

            let adjustedValue = forecast.adjustedValue;
            if(adjustedValue != null){
                adjustedValue = Math.round(parseInt(forecast.adjustedValue) * uomScaleFactor);

                if(varietyTotals[varietyKey].overall.adjustedValue == null){
                    varietyTotals[varietyKey].overall.adjustedValue = 0;
                }
                varietyTotals[varietyKey].overall.adjustedValue += parseInt(adjustedValue);

                if(varietyTotals[varietyKey].dates[dateKey].adjustedValue == null){
                    varietyTotals[varietyKey].dates[dateKey].adjustedValue = 0;
                }
                varietyTotals[varietyKey].dates[dateKey].adjustedValue += parseInt(adjustedValue);

                if(varietyTotals[varietyKey].weeks[weekKey].adjustedValue == null){
                    varietyTotals[varietyKey].weeks[weekKey].adjustedValue = 0;
                }
                varietyTotals[varietyKey].weeks[weekKey].adjustedValue += parseInt(adjustedValue);
            }

            let actualValue = forecast.actualValue;
            if(actualValue != null){
                actualValue = Math.round(parseInt(forecast.actualValue) * uomScaleFactor);

                if(varietyTotals[varietyKey].overall.actualValue == null){
                    varietyTotals[varietyKey].overall.actualValue = 0;
                }
                varietyTotals[varietyKey].overall.actualValue += parseInt(actualValue);

                if(varietyTotals[varietyKey].dates[dateKey].actualValue == null){
                    varietyTotals[varietyKey].dates[dateKey].actualValue = 0;
                }
                varietyTotals[varietyKey].dates[dateKey].actualValue += actualValue;

                if(varietyTotals[varietyKey].weeks[weekKey].actualValue == null){
                    varietyTotals[varietyKey].weeks[weekKey].actualValue = 0;
                }
                varietyTotals[varietyKey].weeks[weekKey].actualValue += actualValue;
            }

            let dayValue = 0;
            if(actualValue != null && actualValue > 0){ // 0s for Actual are treated as null
                dayValue = parseInt(actualValue);
            } else if(adjustedValue != null){
                dayValue = parseInt(adjustedValue);
            } else if(forecastValue != null){
                dayValue = parseInt(forecastValue);
            }

            let cropKey = `${forecast.cropLocationId}`
            let crop = cropByCropLocationId[cropKey];
            let nuPointSprayKey = `${dateKey}-${crop.locationId}`;
            let isICA = false;
            
            if(nuPointSpraysByDateAndLocation[nuPointSprayKey] != null) {
                isICA = nuPointSpraysByDateAndLocation[nuPointSprayKey].some(ns => ns.ICAProtected);
            }

            let icaDayValue = 0;
            if(isICA) {
                icaDayValue = dayValue;
            }

            if(dayGrandTotals[dateKey] == null){
                dayGrandTotals[dateKey] = {
                    total: 0,
                    icaTotal: 0,
                    actualTotal: 0
                };
            }
            
            dayGrandTotals[dateKey].total += dayValue;
            dayGrandTotals[dateKey].icaTotal += icaDayValue;
            dayGrandTotals[dateKey].actualTotal += (actualValue != null && actualValue > 0 ? actualValue : 0);

            if(weekGrandTotals[weekKey] == null){
                weekGrandTotals[weekKey] = {
                    total: 0,
                    icaTotal: 0,
                    actualTotal : 0
                };
            }
            
            weekGrandTotals[weekKey].total += dayValue;
            weekGrandTotals[weekKey].icaTotal += icaDayValue;
            weekGrandTotals[weekKey].actualTotal += (actualValue != null && actualValue > 0 ? actualValue : 0);

            if(varietyTotals[varietyKey].weeks[weekKey].dayValue == null){
                varietyTotals[varietyKey].weeks[weekKey].dayValue = 0;
            }
            varietyTotals[varietyKey].weeks[weekKey].dayValue += dayValue;
        }

        // End of day processing

        // Build the calendarDayTotals object
        if(dayGrandTotals[dateKey] != null){
            data.calendarDayTotals.push({
                startOfWeek: weekKey,
                day: dateKey,
                total: dayGrandTotals[dateKey].total,
                icaTotal: dayGrandTotals[dateKey].icaTotal,
                actualTotal: dayGrandTotals[dateKey].actualTotal
            })
        }

        // Increment the day
        currentDateMoment = currentDateMoment.add(1, 'day');

        // End of week processing
        let everySeventhIteration = i % 7 == 6;
        if(everySeventhIteration){
            //add Monday for next week
            var forwardWeek = momentCache.createMoment(weekKey).add(1, 'week').startOf('week').format("YYYY-MM-DD");
            daysInWeek[weekKey].push(forwardWeek);

            // Process the selected week
            let weekUnixDays = ForecastingUtilService.unixDay(currentWeekMoment);
            let isActiveWeek = weekUnixDays == startOfSelectedWeekUnixDays;
            let weekContainsToday = weekUnixDays == startOfTodayWeekUnixDays;
            let weekBeforeToday = weekUnixDays < startOfTodayWeekUnixDays;
            let weekAfterToday = weekUnixDays > startOfTodayWeekUnixDays;

            if(isActiveWeek){
                // Decide which varieties will be included for the selected week
                for(let j = 0; j < varieties.length; j++){
                    let variety = varieties[j];
                    let varietyKey = `${variety.cropLocationId}-${variety.varietyId}`;

                    // If this variety is not an included variety, skip it
                    if(includedVarietiesByCropLocationIdVarietyId[varietyKey] == null){
                        continue;
                    }

                    let nextPickDateUnixDays = ForecastingUtilService.unixDay(momentCache.getMoment(variety.nextPickDate));

                    let isIncludedInCalendarView = false;
                    
                    if(!allActiveLocations){
                        // All active Past Weeks
                        if(weekContainsToday || weekBeforeToday){
                            // If the variety has any forecast, adjusted or actual values within the week
                            let totals = varietyTotals[varietyKey];
                            if(totals != null){
                                let weekTotals = totals.weeks[weekKey];
                                if(weekTotals != null){
                                    if(weekTotals.forecastValue != null && weekTotals.forecastValue > 0){
                                        isIncludedInCalendarView = true;
                                    }
    
                                    if(weekTotals.adjustedValue != null && weekTotals.adjustedValue > 0){
                                        isIncludedInCalendarView = true;
                                    }
    
                                    if(weekTotals.actualValue != null && weekTotals.actualValue > 0){
                                        isIncludedInCalendarView = true;
                                    }
                                }
                            }
                        }
    
                        // All active Future Weeks
                        if(weekContainsToday || weekAfterToday){
                            let weekSaturdayUnixDays = weekUnixDays + 6;
    
                            // If the variety is next due to be picked before or within the week
                            if(nextPickDateUnixDays <= weekSaturdayUnixDays){
                                isIncludedInCalendarView = true;
                            }
                        }
                    }
                    else {
                        // If the variety has any forecast or actual values within the week
                        let totals = varietyTotals[varietyKey];
                        if(totals != null){
                            let weekTotals = totals.weeks[weekKey];
                            if(weekTotals != null){
                                if(weekTotals.adjustedValue != null && weekTotals.adjustedValue > 0) {
                                    isIncludedInCalendarView = true;
                                }
                                if(weekTotals.forecastValue != null && weekTotals.forecastValue > 0){
                                    if(weekTotals.adjustedValue != null && weekTotals.adjustedValue == 0) {
                                        // forecast has been overwritten, skip
                                    }
                                    else {
                                        isIncludedInCalendarView = true;
                                    }
                                }
                                if(weekTotals.actualValue != null && weekTotals.actualValue > 0){
                                    isIncludedInCalendarView = true;
                                }
                            }
                        }
                    }                    

                    if(isIncludedInCalendarView){
                        calendarVarieties.push(varietyKey);
                    }

                    let isIncludedInListView = false;

                    // If the variety is next due to be picked in the future
                    if(nextPickDateUnixDays > todayUnixDays){
                        isIncludedInListView = true;
                    }

                    if(isIncludedInListView){
                        listVarieties.push(varietyKey);
                    }
                }
            }

            // Build the detailedWeeks object as map
            var weekContainsHoliday = false;
            let detailedDays = daysInWeek[weekKey].reduce((a, v) => {
                let dateKey = v;
                let unixDays = ForecastingUtilService.unixDay(momentCache.getMoment(dateKey));
                let holidayIndex = applicableHolidays.findIndex(h => h.Date == dateKey)

                a[dateKey] = {
                    day: dateKey,
                    unixDays: unixDays,
                    isToday: unixDays == todayUnixDays,
                    forecastLocked: ForecastingUtilService.isForecastLocked(dateKey),
                    adjustedForecastLocked: ForecastingUtilService.isAdjustedForecastLocked(dateKey),
                    publicHoliday: holidayIndex > -1,
                    holidayName: holidayIndex > -1 ? applicableHolidays[holidayIndex].HolidayName : null
                };
                
                if(a[dateKey].publicHoliday){
                    weekContainsHoliday = true
                }

                return a;
            }, {});
            detailedWeeks[weekKey] = {
                week: weekKey,
                isActiveWeek: isActiveWeek,
                isFutureWeek: weekAfterToday,
                days: detailedDays,
                publicHoliday: weekContainsHoliday,
                financialWeek: ForecastingUtilService.getFinancialWeek(weekKey, financialYearCalendarData),
                financialYear: ForecastingUtilService.getFinancialYear(weekKey, financialYearCalendarData),
                locked: !Object.keys(detailedDays).some(
                    x => !detailedDays[x].forecastLocked || !detailedDays[x].adjustedForecastLocked
                ),
                yieldedCrops: [],
                profiledCrops: []
            };

            // Build the calendarWeekTotals object
            if(weekGrandTotals[weekKey] != null){
                data.calendarWeekTotals.push({
                    week: weekKey,
                    total: weekGrandTotals[weekKey].total,
                    icaTotal: weekGrandTotals[weekKey].icaTotal,
                    actualTotal: weekGrandTotals[weekKey].actualTotal
                })
            }

            // Increment the week
            currentWeekMoment = currentWeekMoment.add(7, 'day');
        }
    }

    // Convert detailed weeks from map to list
    data.detailedWeeks = Object.keys(detailedWeeks).map(x => {
        return {
            ...detailedWeeks[x],
            days: Object.keys(detailedWeeks[x].days).map(y => detailedWeeks[x].days[y])
        };
    });

    // Build each row object
    let varietyDetails = {};
    let listAndCalendarVarieties = [].concat(listVarieties).concat(calendarVarieties);
    for(let i = 0; i < listAndCalendarVarieties.length; i++){
        let varietyKey = listAndCalendarVarieties[i];

        // If this variety has already been processed, skip it
        if(varietyDetails[varietyKey] != null){
            continue;
        }

        let variety = varietyByCropLocationIdVarietyId[varietyKey];
        let cropKey = `${variety.cropLocationId}`;
        let crop = cropByCropLocationId[cropKey];

        // Gather row data
        let totals = varietyTotals[varietyKey];

        // Determine next pick date related values
        let nextPickDateMoment = momentCache.getMoment(variety.nextPickDate);
        let nextPickDateUnixDays = ForecastingUtilService.unixDay(nextPickDateMoment);
        let nextPickDate = nextPickDateMoment.format('YYYY-MM-DD')
        let nextPickDateForecast = {
                cropLocationId: variety.cropLocationId,
                varietyId: variety.varietyId,
                day: nextPickDate,
                startOfWeek: nextPickDateMoment.clone().startOf("week").format("YYYY-MM-DD"),
                isToday: nextPickDate == today,
                forecastValue: "",
                forecastValueLocked: ForecastingUtilService.isForecastLocked(nextPickDate),
                adjustedValue: "",
                adjustedValueLocked: ForecastingUtilService.isAdjustedForecastLocked(nextPickDate),
                actualValue: "",
                isRotationDay: true, // This is the next pick date, it is by definition a rotation day
                isSpray: false
            };

        let forecastKey = `${nextPickDate}-${variety.cropLocationId}-${variety.varietyId}`;
        if(forecastByDateCropLocationIdVarietyId[forecastKey] != null){
            let forecast = forecastByDateCropLocationIdVarietyId[forecastKey];

            if(forecast != null){
                if(forecast.forecastValue != null) {
                    nextPickDateForecast.forecastValue = Math.round(parseInt(forecast.forecastValue) * uomScaleFactor);
                }
                if(forecast.adjustedValue != null) {
                    nextPickDateForecast.adjustedValue = Math.round(parseInt(forecast.adjustedValue) * uomScaleFactor);
                }
                if(forecast.actualValue != null) {
                    nextPickDateForecast.actualValue = Math.round(parseInt(forecast.actualValue) * uomScaleFactor);
                }

                nextPickDateForecast.isSpray = forecast.isSpray;
            }
        }

        // Determine note related values
        let itemNotes = notesByCropLocationIdVarietyId[varietyKey] || [];
        let minAlertLevel = null;
        let locationHasAlert = false;
        for(let j = 0; j < itemNotes.length; j++){
            let itemNote = itemNotes[j];
            if(!itemNote.isClosed){
                if(itemNote.alertLevel < minAlertLevel || minAlertLevel == null){
                    minAlertLevel = itemNote.alertLevel;
                }

                if(itemNote.alertLevel > 0){
                    locationHasAlert = true;
                }
            }
        }
        let locationAlertLevelColor = ForecastingUtilService.getAlertLevelColor(minAlertLevel);

        // Build a map of week to budget values
        let budgetValues = {};
        if(variety.activeProfile != null && variety.activeProfile.VarietyID > 0 && variety.activeProfile.BudgetValues != null){
            for(let j = 0; j < variety.activeProfile.BudgetValues.length; j++){
                let budgetValue = variety.activeProfile.BudgetValues[j];
                let budgetWeek = variety.activeProfile.StartWeek + budgetValue.BerriesForecastProfileWeekNumber - 1;

                budgetValues[budgetWeek] = budgetValue.BudgetValue;
            }
        }

        // Build up each week object
        let forecastWeeks = Object.keys(detailedWeeks).map(x => {
            let weekKey = x;
            let weekTotals = null;
            if(totals != null){
                weekTotals = totals.weeks[weekKey];
            }
            if(weekTotals == null){
                weekTotals = {
                    forecastValue: 0,
                    adjustedValue: 0,
                    actualValue: 0,
                    dayValue: 0
                };
            }

            let detailedWeek = detailedWeeks[weekKey];

            let budgetValue = budgetValues[detailedWeek.financialWeek];
            let totalProfiles = budgetValue != null ? Math.round(budgetValue * (variety.activeProfile.TonnesPerHectare * variety.activeProfile.CropArea * 1000)) : null;

            // Build up each day object
            let forecastDays = daysInWeek[x].map(y => {
                let dateKey = y;
                let dateTotals = null;
                if(totals != null){
                    dateTotals = totals.dates[dateKey];
                }
                if(dateTotals == null){
                    dateTotals = {
                        forecastValue: null,
                        adjustedValue: null,
                        actualValue: null
                    };
                }

                let detailedDay = detailedWeek.days[dateKey];

                let daysSinceNextPickDate = detailedDay.unixDays - nextPickDateUnixDays;
                let isRotationDay = false;
                if(daysSinceNextPickDate == 0){
                    isRotationDay = true;
                } else if(variety.rotationDays != null && daysSinceNextPickDate > 0) {
                    isRotationDay = daysSinceNextPickDate % variety.rotationDays == 0;
                }

                // Look for Spray days
                let forecastKey = `${dateKey}-${variety.cropLocationId}-${variety.varietyId}`;
                let isSpray = false;
                let hasRoster = false;
                if(forecastByDateCropLocationIdVarietyId[forecastKey] != null) {
                    let forecast = forecastByDateCropLocationIdVarietyId[forecastKey];
                    isSpray = forecast.isSpray;
                    hasRoster = forecast.hasRoster;
                }

                // Look for NuPoint Sprays
                let nuPointSprayKey = `${dateKey}-${crop.locationId}`;
                let nuPointSprays = [];
                if(nuPointSpraysByDateAndLocation[nuPointSprayKey] != null) {
                    nuPointSprays = nuPointSpraysByDateAndLocation[nuPointSprayKey];                    
                }

                let WithholdColour = "";
                if (nuPointSprays.some(ns => ns.Withholding)) {
                    WithholdColour = nuPointSprays.filter(ns => ns.Withholding)[0].WithholdColour;
                }

                let ICAColour = "";
                if(nuPointSprays.some(ns => ns.ICA)) {
                    ICAColour = nuPointSprays.filter(ns => ns.ICA)[0].ICAColour;
                }

                // Return the day object
                return {
                    cropLocationId: variety.cropLocationId,
                    varietyId: variety.varietyId,
                    day: dateKey,
                    startOfWeek: weekKey,
                    isToday: dateKey == today,
                    isRotationDay: isRotationDay,
                    isSpray: isSpray,
                    hasRoster: hasRoster,
                    forecastValue: dateTotals.forecastValue != null ? dateTotals.forecastValue : "",
                    forecastValueLocked: detailedDay.forecastLocked,
                    adjustedValue: dateTotals.adjustedValue != null ? dateTotals.adjustedValue : "",
                    adjustedValueLocked: detailedDay.adjustedForecastLocked,
                    actualValue: dateTotals.actualValue != null ? dateTotals.actualValue : "",
                    nuPointSprays: nuPointSprays,
                    WithholdColour: WithholdColour,
                    Withholding: nuPointSprays.some(ns => ns.Withholding),
                    ICA: nuPointSprays.some(ns => ns.ICA),
                    ICAProtected: nuPointSprays.some(ns => ns.ICAProtected),
                    ICAColour: ICAColour
                };
            });

            let yieldValue = yieldMap[`${detailedWeek.financialYear}-${detailedWeek.financialWeek}-${variety.locationId}-${variety.varietyId}`];

            if(yieldValue) {
                if(detailedWeek.yieldedCrops.find(y=> y.week == detailedWeek.week && y.cropLocationId == variety.cropLocationId && y.varietyId == variety.varietyId) == null) {
                    detailedWeek.yieldedCrops.push({week: detailedWeek.week, cropLocationId: variety.cropLocationId, varietyId: variety.varietyId});
                }
            }

            if(totalProfiles) {
                if(detailedWeek.profiledCrops.find(y=> y.week == detailedWeek.week && y.cropLocationId == variety.cropLocationId && y.varietyId == variety.varietyId) == null) {
                    detailedWeek.profiledCrops.push({week: detailedWeek.week, cropLocationId: variety.cropLocationId, varietyId: variety.varietyId});
                }
            }

            // Return the week object
            return {
                week: weekKey,
                isActiveWeek: detailedWeek.isActiveWeek,
                isFutureWeek: detailedWeek.isFutureWeek,
                forecastDays,
                totalActuals: weekTotals.actualValue,
                totalYields: yieldValue == null ? "" : Math.round(yieldValue * uomScaleFactor),
                totalProfiles: totalProfiles == null ? "" : Math.round(totalProfiles * uomScaleFactor),
                totalICA: weekTotals.iCAValue,
                total: weekTotals.dayValue,
                locked: detailedWeek.locked,
                hasNuPointSprayWithholding: forecastDays.some(d => d.Withholding),
                hasNuPointSprayICA: forecastDays.some(d => d.ICA),
                isNuPointSprayICAProtected: forecastDays.some(d => d.ICAProtected)
            };
        });
        let locationNameSorting = crop.locationName.replace(/[^\d\s\w]+/g, ''); 
        // Create the row object
        varietyDetails[varietyKey] = {
            cropLocationId: variety.cropLocationId,
            varietyId: variety.varietyId,
            locationName: crop.locationName,
            locationNameSorting: locationNameSorting,
            cropArea: crop.cropArea,
            rotationDays: variety.rotationDays,
            varietyName: variety.varietyName,
            nextPickDate: nextPickDate,
            nextPickDateMoment: nextPickDateMoment,
            nextPickDateForecast: nextPickDateForecast,
            nextPickDateMovedDays: variety.nextPickDateMovedDays,
            lastPickActualValue: variety.lastPickActualValue,
            locationHasAlert,
            locationAlertLevelColor,
            forecastWeeks,
            editable: editable
        };
    }

    // Return the row objects for list
    data.listSortedItems = listVarieties
        .map(varietyKey => varietyDetails[varietyKey])
        .filter(x => x != null)
        .sort((a, b) => {
            let aNextPickDate = a.nextPickDateMoment;
            let bNextPickDate = b.nextPickDateMoment;

            if(aNextPickDate > bNextPickDate){
                return 1;
            }

            if(aNextPickDate < bNextPickDate){
                return -1;
            }

            if(a.locationName > b.locationName){
                return 1;
            }

            if(a.locationName < b.locationName){
                return -1;
            }
            
            return 0;
        });      

    for (let i = data.listSortedItems.length - 1; i >= 0; i--) {        
        if (data.listSortedItems[i + 1]) {
            data.listSortedItems[i].nextListItem = { cropLocationId: data.listSortedItems[i + 1].cropLocationId, varietyId: data.listSortedItems[i + 1].varietyId };
        }
    }

    data.listNumberOfLocationsFiltered = Object.keys(data.listSortedItems.reduce((a, v) => {
        a[v.cropLocationId] = true;

        return a;
    }, {})).length;

    // Return the row objects for calendar
    data.calendarSortedItems = calendarVarieties
        .map(varietyKey => varietyDetails[varietyKey])
        .filter(x => x != null)
        .sort((a, b) => {
            if(a.locationNameSorting > b.locationNameSorting){
                return 1;
            }

            if(a.locationNameSorting < b.locationNameSorting){
                return -1;
            }

            let aNextPickDate = a.nextPickDateMoment;
            let bNextPickDate = b.nextPickDateMoment;

            if(aNextPickDate > bNextPickDate){
                return 1;
            }

            if(aNextPickDate < bNextPickDate){
                return -1;
            }
            
            return 0;
        })

    for (let i = data.calendarSortedItems.length - 1; i >= 0; i--) {
        if(data.calendarSortedItems[i + 1]) {
            data.calendarSortedItems[i].next = {cropLocationId: data.calendarSortedItems[i + 1].cropLocationId, varietyId: data.calendarSortedItems[i + 1].varietyId };
        }
    }

    data.calendarNumberOfLocationsFiltered = Object.keys(data.calendarSortedItems.reduce((a, v) => {
        a[v.cropLocationId] = true;

        return a;
    }, {})).length;

    // Used for Debugging
    //let endDate = new Date();
    //let seconds = (endDate.getTime() - startDate.getTime()) / 1000;
    //console.log(seconds + " seconds");

    return {
        detailedWeeks: data.detailedWeeks,
        calendarDayTotals: data.calendarDayTotals,
        calendarWeekTotals: data.calendarWeekTotals,
        listSortedItems: data.listSortedItems,
        listNumberOfLocationsFiltered: data.listNumberOfLocationsFiltered,
        calendarSortedItems: data.calendarSortedItems,
        calendarNumberOfLocationsFiltered: data.calendarNumberOfLocationsFiltered
    };
}

export default {
    getUpdatedData
}